import { useTranslation } from 'react-i18next';

import LoadingPage from '@/components/common/LoadingPage';
import SubPageHeader from '@/components/common/SubPageHeader';
import hasItems from '@/lib/utils/hasItems';

import useSelectedParty from '../analysis/hooks/useSelectedParty';

import NoteItem from './components/NotesSection/NoteItem';
import useNotes from './queries/hooks/useNotes';

export default function NotesOverview() {
  const { t } = useTranslation();

  const party = useSelectedParty();

  const { data: notes, isLoading } = useNotes(party?.id ?? '', {
    enabled: Boolean(party?.id),
  });

  return (
    <div className="flex h-screen flex-col overflow-hidden">
      <SubPageHeader>{t('NOTES_TITLE')}</SubPageHeader>

      <main className="flex flex-1 flex-col gap-2 overflow-y-auto p-2">
        {isLoading && <LoadingPage />}

        {!isLoading &&
          hasItems(notes) &&
          notes.map((note) => <NoteItem key={note.activity_id} note={note} />)}
      </main>
    </div>
  );
}
